<template>
    <div class="col-12 p-4 row justify-content-center">
        <h2 class="title col-12">
            {{ t("gifs.edit") }}
        </h2>

        <div
            class="col-12 card card-outline card-primary p-2"
            :class="{ 'col-md-8': forms == 1 }"
            v-if="!loading && treino.id"
        >
            <form @submit.prevent="submit" class="row flex-wrap col-12">
                <input
                    type="file"
                    class="d-none"
                    name="imagefile"
                    ref="file"
                    @change="addImage"
                />
                <div class="col-12 p-2">
                    <label>{{
                        t(
                            isProfile
                                ? "student-profile.name"
                                : "exercices.title",
                        )
                    }}</label>
                    <div
                        class="row p-o m-0 justify-content-between align-items-center"
                    >
                        <InputColor
                            v-model:pure-color="treino.colors.title[0]"
                            style="width: 2rem; height: 2rem"
                        />

                        <input
                            type="text"
                            v-model="treino.title"
                            class="form-control"
                            :placeholder="
                                t(
                                    isProfile
                                        ? 'student-profile.name'
                                        : 'gifs.title',
                                )
                            "
                            required
                            style="
                                flex: 1 !important;
                                text-align: center;
                                text-transform: uppercase;
                            "
                            :style="{
                                backgroundColor: treino.colors.title[0],
                                color: treino.colors.title[1],
                            }"
                        />

                        <InputColor
                            v-model:pure-color="treino.colors.title[1]"
                            style="width: 2rem; height: 2rem"
                        />
                    </div>
                </div>
                <div
                    class="row m-0 p-0 col-12 gap-1"
                    v-for="i in forms"
                    :key="i"
                    :class="{ 'col-md-12': forms == 1, 'col-md-6': forms > 1 }"
                >
                    <hr class="hr col-12" v-if="forms > 1" />
                    <h5 class="h5 text-bold col-12" v-if="forms > 1">
                        {{ t("new.ex" + i) }}
                    </h5>
                    <div class="col-12 col-md-7">
                        <!-- duration	charge	series	group	 -->
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_duration' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.duration'
                                                : 'gifs.duration',
                                        )
                                    "
                                    v-model="fillVar(i)['h_duration']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.duration[0],
                                        color: fillVar(i).colors.duration[1],
                                    }"
                                />
                                <label
                                    :for="'h_duration' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['duration']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.duration'
                                            : 'gifs.duration',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_charge' + i"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.charge'
                                                : 'gifs.charge',
                                        )
                                    "
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_charge']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.charge[0],
                                        color: fillVar(i).colors.charge[1],
                                    }"
                                />
                                <label
                                    :for="'h_charge' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['charge']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.charge'
                                            : 'gifs.charge',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_series' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.series'
                                                : 'treinos.exercices.series',
                                        )
                                    "
                                    v-model="fillVar(i)['h_series']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.series[0],
                                        color: fillVar(i).colors.series[1],
                                    }"
                                />
                                <label
                                    :for="'h_series' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['series']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.series'
                                            : 'treinos.exercices.series',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_group' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.group'
                                                : 'gifs.group',
                                        )
                                    "
                                    v-model="fillVar(i)['h_group']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.group[0],
                                        color: fillVar(i).colors.group[1],
                                    }"
                                />
                                <label
                                    :for="'h_group' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['group']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.group'
                                            : 'gifs.group',
                                    )
                                "
                            />
                        </div>
                        <template v-if="isProfile">
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_imc' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="t('student-profile.imc')"
                                        v-model="fillVar(i)['h_imc']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.imc[0],
                                            color: fillVar(i).colors.imc[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_imc' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['imc']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.imc')"
                                />
                            </div>
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_magra' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="
                                            t('student-profile.magra')
                                        "
                                        v-model="fillVar(i)['h_magra']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.magra[0],
                                            color: fillVar(i).colors.magra[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_magra' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['magra']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.magra')"
                                />
                            </div>
                        </template>
                    </div>
                    <div
                        class="col-12 col-md-5 position-relative overflow-auto"
                    >
                        <template v-if="isProfile">
                            <div
                                style="
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: nowrap;
                                    width: 100%;
                                    overflow-x: scroll;
                                "
                            >
                                <div
                                    v-for="(img, i) in images"
                                    :key="i"
                                    class="col-11 mx-1 position-relative d-flex justify-content-center"
                                    style="background: rgba(180, 180, 180, 0.5)"
                                >
                                    <button
                                        class="btn btn-danger position-absolute text-white top-0 left-0"
                                        type="button"
                                        @click="() => removeImage(i, false)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <img
                                        :src="img"
                                        style="
                                            max-height: 250px;
                                            max-width: 100%;
                                        "
                                    />
                                </div>
                            </div>
                            <button
                                v-if="images.length < 4"
                                class="btn btn-warning position-absolute text-white bottom-0 right-0"
                                type="button"
                                @click="selectFile"
                            >
                                <i class="fa fa-plus-circle"></i>
                            </button>
                        </template>
                        <template v-else>
                            <img
                                v-if="!fillVar(i).usergif"
                                class="image-responsive responsive col-12"
                                style="min-height: 3rem"
                                :src="imgs[i]"
                            />
                            <img
                                v-else
                                class="image-responsive responsive col-12"
                                style="min-height: 3rem"
                                :src="imgs2[i]"
                            />
                            <button
                                class="btn btn-warning position-absolute text-white bottom-0 right-0"
                                type="button"
                                @click="() => openModal(i)"
                            >
                                <i class="fa fa-image"></i>
                            </button>
                        </template>
                        <!-- <img class="image-responsive responsive col-12" style="min-height: 3rem" :src="imgs[i]">
                        <button class="btn btn-warning position-absolute text-white bottom-0 right-0" type="button"
                            @click="() => openModal(i)"
                        >
                            <i class="fa fa-image"></i>
                        </button> -->
                    </div>
                    <div class="col-12">
                        <div class="col-12 p-2">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :placeholder="t('treinos.objectives')"
                                    :id="`h_description` + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_description']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.description[0],
                                        color: fillVar(i).colors.description[1],
                                    }"
                                />
                                <label
                                    :for="'h_description' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <textarea
                                class="form-control"
                                rows="5"
                                :name="'objetivos' + i"
                                v-model="fillVar(i)['description']"
                                maxlength="1500"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 py-2">
                    <button class="btn btn-primary mx-2" type="submit">
                        {{ t("treinos.update") }}
                    </button>
                    <button
                        class="btn btn-warning mx-2"
                        @click="back"
                        type="button"
                    >
                        <i class="fa fa-arrow-left mr-2"></i>
                        {{ t("general.back") }}
                    </button>
                </div>
            </form>
        </div>

        <modal-component
            @hide="() => (this.showModal = false)"
            :show="showModal"
            :classList="['col-12']"
            :title="t('gifs.select')"
        >
            <select-gif-component
                @selectGif="select"
                @selectPremium="selectPremium"
            ></select-gif-component>
        </modal-component>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { t } from "@/lang";
import Api from "@/utilities/Api";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import SelectGifComponent from "../../components/SelectGifComponent.vue";
import { getExImage } from "@/utilities/HelpFunctions.js";
import InputColor from "@/components/InputColor.vue";

export default {
    name: "NewTreinoView",
    data() {
        return {
            showModal: false,
            newImages: [],
            deletedImages: [],
            urls: [],
            treino: {
                title: "",

                duration: "",
                charge: "",
                series: "",
                group: "",
                description: "",
                imc: "",
                magra: "",

                h_imc: "",
                h_magra: "",
                h_duration: t("gifs.duration"),
                h_charge: t("gifs.charge"),
                h_series: t("treinos.exercices.series"),
                h_group: t("gifs.group"),
                h_description: t("treinos.objectives"),
                path: null,
                fitnes_id: null,
                id: null,
                child: null,
                images: [],
                usergif: 0,
                userGifUrl: null,

                colors: {
                    title: ["#808080", "#333333"],
                    duration: ["#d0d0d0", "#000000"],
                    charge: ["#d0d0d0", "#000000"],
                    series: ["#d0d0d0", "#000000"],
                    group: ["#d0d0d0", "#000000"],
                    imc: ["#d0d0d0", "#000000"],
                    magra: ["#d0d0d0", "#000000"],
                    description: ["#d0d0d0", "#000000"],
                },
            },
            selected: 1,
            isProfile: false,
        };
    },
    components: {
        ModalComponent,
        SelectGifComponent,
        InputColor,
    },
    async created() {
        document.title = t("gifs.menu");
        await this.getExercice();
    },
    computed: {
        ...mapState(["loading"]),
        imgs() {
            return {
                1: `${Api.url}images/GIFS/${this.treino.path}`,
                2: this.treino.child
                    ? `${Api.url}images/GIFS/${this.treino.child.path}`
                    : "",
            };
        },
        imgs2() {
            return {
                1: this.treino.userGifUrl,
                2: this.treino.child ? this.treino.child.userGifUrl : "",
            };
        },
        images() {
            return this.urls.concat(
                this.newImages.map((img) => URL.createObjectURL(img)),
            );
        },
        forms() {
            return this.treino.child ? 2 : 1;
        },
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_LOADING"]),
        t,
        back() {
            this.$router.push("/fitnes/" + this.treino.fitnes_id);
        },
        getUrl(img) {
            return Api.url + "images/players/" + img;
        },
        fillVar(i) {
            return i == 1 ? this.treino : this.treino.child;
        },
        select(path, usergif = 0, name = undefined) {
            this.fillVar(this.selected).path = usergif ? name : path;
            this.fillVar(this.selected).usergif = usergif;
            this.fillVar(this.selected).userGifUrl = usergif ? path : null;
            this.showModal = false;
        },
        selectPremium(path, src) {
            this.fillVar(this.selected).path = path;
            this.fillVar(this.selected).usergif = 2;
            this.fillVar(this.selected).userGifUrl = src;
            this.showModal = false;
        },
        async getExercice() {
            this.SET_LOADING(true);

            const id = this.$route.params.id;
            const response = await this.get({ url: "fitnesex/" + id + "/get" });
            if (response.status == 200) {
                this.treino = response.data.exercice;
                console.log(this.treino);
                if (this.treino.images.length > 0) {
                    this.urls = [];
                    this.treino.images.forEach(async ({ id }) => {
                        const url = await getExImage(
                            "",
                            this.get,
                            `fitnesex/image/${id}`,
                            "image/png",
                        );
                        this.urls.push(url);
                    });
                    this.profile();
                } else {
                    await this.getUserGifUrl(this.treino);
                    if (this.treino.child) {
                        await this.getUserGifUrl(this.treino.child);
                    }
                }
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else if (response.status == 404) {
                alert("Nao encontrado");
                this.$router.push("/fitnes");
            } else {
                alert(response.data.message);
                this.$router.push("/fitnes");
            }
            this.SET_LOADING(false);
        },
        async getUserGifUrl(parent) {
            if (parent.usergif) {
                let url;
                if (parent.usergif == 2) {
                    url = await getExImage(
                        "",
                        this.get,
                        `premiun-gifs/get?path=${parent.path.replace("premium_gifs/", "")}`,
                        "image/gif",
                    );
                } else {
                    url = await getExImage(
                        "",
                        this.get,
                        "user-gifs/download?path=" + parent.path,
                        "image/gif",
                    );
                }
                parent.userGifUrl = url;
            }
        },
        async updateImages() {
            let go = true;
            if (this.deletedImages.length > 0) {
                console.log("Okay vamos");
                const data = new URLSearchParams();
                this.deletedImages.forEach((id, i) =>
                    data.append(`images[${i}]`, id),
                );
                console.log("Okay vamos 2");
                const res = await this.delete({
                    url:
                        "fitnesex/" +
                        this.treino.id +
                        "/images?" +
                        data.toString(),
                });
                console.log("Okay vamos 3");
                if (res.status < 200 || res.status >= 300) {
                    alert("Erro ao apagar imagens \n\n" + res.data.message);
                    go = false;
                }
            }

            if (this.newImages.length > 0) {
                const data = new FormData();
                this.newImages.forEach((blob, i) =>
                    data.append(`images[${i}]`, blob),
                );
                const res = await this.post({
                    url: "fitnesex/" + this.treino.id + "/images",
                    data: data,
                    FormData: data,
                });
                if (res.status < 200 || res.status >= 300) {
                    alert(
                        "Erro ao enviar novas imagens \n\n" + res.data.message,
                    );
                    go = false;
                }
            }

            return go;
        },
        openModal(i) {
            this.selected = i;
            this.showModal = true;
        },
        createUrl(blob) {
            return URL.createObjectURL(blob);
        },
        selectFile() {
            this.$refs.file.click();
        },
        async removeImage(i) {
            if (this.treino.images.length > i) {
                this.deletedImages.push(this.treino.images[i].id);
                this.treino.images.splice(i, 1);
                this.urls.splice(i, 1);
            } else {
                // imagem nova, basta eliminar
                this.newImages.splice(i - this.treino.images.length, 1);
            }
        },
        addImage(event) {
            if (this.images.length < 4) {
                if (event && event.target && event.target.files) {
                    const [file] = event.target.files;
                    if (file) {
                        this.newImages.push(file);
                        console.log("Adiciona imagem");
                    }
                }
            }
        },
        async submit() {
            if (!this.treino.path) {
                alert(t("gifs.select"));
                return null;
            }
            this.SET_LOADING(true);
            const imgsRes = await this.updateImages();
            console.log(imgsRes);
            if (imgsRes) {
                console.log(this.treino.h_duration);
                this.treino.usergif = Number(this.treino.usergif);
                if (this.treino.child) {
                    this.treino.child.usergif = Number(
                        this.treino.child.usergif,
                    );
                }
                const response = await this.post({
                    url: "fitnesex/" + this.treino.id,
                    data: this.treino,
                });
                console.log(response);
                if (response.status == 200) {
                    alert(t("general.updated"));
                    this.deletedImages = [];
                    this.newImages = [];
                    await this.getExercice();
                } else {
                    alert(response.data.message);
                }
                console.log(response);
            }
            this.SET_LOADING(false);
        },
        profile() {
            this.isProfile = true;
        },
    },
};
</script>

<style lang="scss" scoped></style>
